<template>
  <div v-bind:class="{ 
      'session-loader': true,
      hide: hideLoader 
    }">
    <div class="loader-content">
    </div>
  </div>
</template>

<script>
export default {
  name: 'session-loader',
  computed: {
    hideLoader () {
      return !this.$store.state.session.showLoader
    }
  }
}
</script>

<style lang="scss" scoped>
.session-loader{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 999;
  opacity: 1;
  transition: all 250ms;

  &.hide {
    opacity: 0;
    top: -100%;
  }
}

.loader-content{
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/App/SessionLoader.vue